'use client';

import { cva } from 'class-variance-authority';
import { useEffect, useRef } from 'react';
import { useIsElementScrolled, cn } from '@bridebook/aura';
import { useRoundedModalContainerContext } from './rounded-modal-container-context';
import { useIsScrolledContext } from '../is-scrolled-context';

const roundedModalContentVariants = cva('flex-1 overflow-y-auto py-3 text-space scrollbar-thin', {
  variants: {
    width: {
      'responsive-sm': 'px-6 text-center lg:px-10 lg:text-left',
      sm: 'px-6 text-center',
      standard: 'px-10 text-left',
      lg: 'px-10 text-left',
    },
  },
});

export const RoundedModalContent = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => {
  const { width } = useRoundedModalContainerContext();
  const ref = useRef<HTMLDivElement>(null);
  const { isScrolled } = useIsElementScrolled(ref);
  const { setIsContentScrolled } = useIsScrolledContext();

  useEffect(() => {
    setIsContentScrolled?.(isScrolled);
  }, [isScrolled, setIsContentScrolled]);

  return (
    <div
      data-slot="rounded-modal-content"
      ref={ref}
      className={cn(roundedModalContentVariants({ width }), className)}
      {...props}
    />
  );
};
